import { render, staticRenderFns } from "./RolodexTags.vue?vue&type=template&id=af97d4d6&scoped=true&"
import script from "./RolodexTags.vue?vue&type=script&lang=ts&"
export * from "./RolodexTags.vue?vue&type=script&lang=ts&"
import style0 from "./RolodexTags.vue?vue&type=style&index=0&id=af97d4d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af97d4d6",
  null
  
)

export default component.exports